import React from 'react';
import { Route, AuthUser } from '@/types';
import env from '@/env';

interface AuthorizedProps {
  userInfo?: {
    email: string;
    memberships: { organisationId: string; roleName: string }[];
    userId: string;
  };
  authUser?: AuthUser;
  route?: Route;
  organisationId?: string;
  unauthorizedPage: React.ReactNode;
  children: React.ReactNode;
}

const Authorized = (props: AuthorizedProps) => {
  const { authUser, route, unauthorizedPage, children, organisationId, userInfo } = props;

  const userRoles = !userInfo?.memberships.length
    ? authUser?.roles ?? []
    : authUser?.roles
    ? [
        ...authUser.roles,
        userInfo.memberships.find((entity) => entity.organisationId === organisationId)?.roleName ||
          '',
      ]
    : [];
  const routeRoles = route?.roles ?? [];

  let hasPermission =
    routeRoles.length === 0 ||
    (!!authUser?.organisationId && userRoles.some((role) => routeRoles.includes(role))) ||
    userRoles.includes(env.roles.superAdmin) ||
    userRoles.includes(env.roles.directoryAdmin);

  if (
    route?.organisation &&
    organisationId &&
    !userRoles.includes(env.roles.superAdmin) &&
    !userRoles.includes(env.roles.directoryAdmin)
  ) {
    hasPermission = authUser?.organisationId === organisationId;
  }

  if (!hasPermission) return <>{unauthorizedPage}</>;

  return <>{children}</>;
};

export default Authorized;
